<template>
  <div class="trade-record-box">
    <div class="trade-record-box-title">
      <van-nav-bar>
        <template #left>
          <span class="title">{{ $t("trade.entrust") }}</span>
          <span class="type" @click="showPicker = true"
            >{{ value }} <van-icon name="arrow-down"
          /></span>
        </template>
        <template #right>
          <span class="toall" @click="toall()"
            ><van-icon name="records-o" />{{ $t("common.all") }}</span
          >
        </template>
      </van-nav-bar>
      <div class="trade-record-box-lst">
        <div v-if="true">
          <div v-for="(item, index) in list" :key="index">
            <TradeRecordItem :item="item" @cancel-Order="cancelOrder" />
          </div>
        </div>
        <van-empty v-else :description="$t('common.nodata')" />
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom" round >
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        value-key="label"
        :confirm-button-text="$t('common.confirm')"
        :cancel-button-text="$t('common.cancel')"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import TradeRecordItem from "./recorditem.vue";
export default {
  name: "TradeRecord",
  components: { TradeRecordItem },
  data() {
    return {
      value: "",
      columns: [
        { value: 1, label: this.$t("common.buy") },
        { value: 2, label: this.$t("common.sell") },
      ],
      showPicker: false,
      list: [],
      frm: {
        type: 1,
        page: 1,
        limit: 10,
      },
    };
  },
  mounted() {
    this.onConfirm(this.columns[0]);
    this.onLoad();
  },
  methods: {
    ResetRecord(val){
      this.columns.forEach(element => {
        if(val == element.value){
          this.onConfirm(element)
        }
      });
    },
    onConfirm(val) {
      this.value = val.label;
      this.frm.type = val.value;
      this.showPicker = false;
      this.onLoad()
    },
    async onLoad() {
      await this.$http({
        method: "post",
        url: "tradegetOrderList",
        data: this.frm,
      }).then((res) => {
        this.list = res.data.list;
      });
    },
    cancelOrder(id){
      this.postcancelOrder(id)
    },
    async postcancelOrder(id) {
      await this.$http({
        method: "post",
        url: "tradecancelOrder",
        data: { bb_id:id },
      }).then((res) => {
        this.$toast.success(res.msg)
        this.onLoad()
      });
    },
    toall() {
      this.$router.push(
        {
          name: "trade-lst",
          query: {
            currentSymbol: this.safeTitle,
            name: this.safeName,
          },
        },
        () => {}
      );
    },
  },
};
</script>

<style>
</style>
